import { get, post } from './api';

export const getCartList = function() {
    return post('/placeOrder/queryBookingList');
};

export const addToCart = function(params) {
    return post('/placeOrder/booking', params);
};

export const batchDeleteCart = function(params) {
    return post('/placeOrder/removeBooking', params);
};

export const resetBookingNum = function(params) {
    return post('/placeOrder/resetBookingNum', params);
};

export const clearCart = function() {
    return post('/placeOrder/clearBooking');
};

export const getWayBillMoney = function(params) {
    return post('/placeOrder/queryFareConfig', params);
};

export const createOrder = function(params) {
    return post('/placeOrder/execute', params);
};

export const getOrder = function(params) {
    return post('/userOrder/queryPaging', params);
};

export const getOrderDetail = function(params) {
    return post('/userOrder/queryDetail', params);
};

export const orderDetailPaging = function(params) {
    return post('/userOrder/query/detail/paging', params);
};

export const waitInvoicePaging = function(params) {
    return post('/userOrder/query/wait/invoiced/paging', params);
};

export const invoicePaging = function(params) {
    return post('/userOrder/query/order/goods/invoiced/paging', params);
};

export const invoiceDetail = function(params) {
    return post('/userOrder/query/order/goods/invoiced/detail/paging', params);
};

export const shipPaging = function(params) {
    return post('/userOrder/query/express/order/paging', params);
};

export const shipDetail = function(params) {
    return post('/userOrder/query/express/order/detail/paging', params);
};

export const orderpay = function(params) {
    return post('/pay/pay', params);
};

export const orderpayResult = function(params) {
    return post('/pay/query/pay/result', params);
};

export const querySimpleSysUser = function(params) {
    return post('/userInfo/querySimpleSysUser', params);
};

export const action = function(params) {
    return post('/orderMaster/action', params);
};

export const queryTripartiteExpressInfo = function(params) {
    return get('/userOrder/queryTripartiteExpressInfo?expressNo=' + params.expressNo);
};

export const ticketList = function(params) {
    return post('/ticketsUser/queryUserPaging', params);
};
